import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Toggle global para habilitar/deshabilitar inscripciones (Stripe en modo prueba)
// Cambiar a true cuando la cuenta de Stripe esté en producción
export const REGISTRATION_ENABLED = true;

// Toggle para usar Stripe en modo test (sandbox)
// true = usa STRIPE_TEST_SECRET_KEY (sk_test_...)
// false = usa STRIPE_SECRET_KEY (sk_live_...)
export const STRIPE_TEST_MODE = false;
